<template>
    <v-container fluid style="margin: 60px 10%">
        <v-row>
            <v-col cols="12">
                <v-data-table :items="usuarios" :headers="headerUsuarios"></v-data-table>
            </v-col>
            <v-col cols="12" align="center">
                <v-btn @click="exportCSVFile()" color="primary white--text" x-large>Exportar</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Newsletter',
  data () {
    return {
      usuarios: [],
      headerUsuarios: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Email', value: 'email' },
        { text: 'Ciudad', value: 'ciudad' }
      ],
      headerCSV: {
        nombre: 'Nombre',
        email: 'Email',
        ciudad: 'Ciudad'
      }
    }
  },
  mounted () {
    firebase.firestore().collection('usuarios').where('newsletter', '==', true).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.usuarios.push({
          nombre: info.docs[i].data().nombre,
          email: info.docs[i].data().email,
          ciudad: info.docs[i].data().ciudad
        })
      }
    })
    firebase.firestore().collection('newsletter').where('aprobado', '==', true).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.usuarios.push({
          nombre: info.docs[i].data().nombre,
          email: info.docs[i].data().email,
          ciudad: info.docs[i].data().ciudad
        })
      }
    })
  },
  methods: {
    convertToCSV (objArray) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      let str = ''
      for (let i = 0; i < array.length; i++) {
        let line = ''
        for (let index in array[i]) {
          if (line !== '') line += ','
          line += array[i][index]
        }
        str += line + '\r\n'
      }
      return str
    },
    exportCSVFile () {
      this.usuarios.unshift(this.headerCSV)
      const csv = this.convertToCSV(this.usuarios)
      const exportName = 'newsletter.csv'
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', exportName)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }
  }
}
</script>
